<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="card my-profile-form margin-top-15px top-link" *ngIf="ShowList">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="row">
        <div class="col-md-4">
          External Doctors
        </div>
        <div class="col-md-8 padding-right-0px">
          <div class="row">
            <div class="offset-md-6 col-md-2 padding-right-0px text-align-right">
              <a (click)="AddNewDoctor()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New External Doctors"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
            </div>
            <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
              <form novalidate="" #f="ngForm" class="display-inherit">
                <div class="clear-form">
                  <input type="text" class="form-control" placeholder="Search" name="searchBar" maxlength="15">
                </div>
                <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>

                    <th class="">
                      Code
                    </th>

                    <th class="padding-left-10px">
                      Doctor Name
                    </th>

                    <th class="padding-left-10px">
                      Clinic Name
                    </th>

                    <th class="padding-left-10px">
                      Phone
                    </th>
                    <th class="">

                    </th>

                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr *ngFor="let l of CurrentExternalDoctorsListController">

                    <td class=" td-padding-tb">{{l.DocCode}}</td>
                    <td class=" td-padding-tb">{{l.DisplayName}}</td>
                    <td class="td-padding-tb">{{l.ClinicName}}</td>
                    <td class="td-padding-tb ">{{l.Telephone1}}</td>
                    <td class=" td-padding-tb ">
                      <button (click)="EditDoc(l)" type="submit" class="button-service-save padding-right-15px font-size-16px color-secondary nav-link-hand margin-left-3px"><i class="fas fa-pencil-alt"></i></button>
                      <a class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                    </td>

                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card my-profile-form margin-top-15px top-link" *ngIf="AddDoctor">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="col-md-12">
        <div class="row">
          <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel()" title="Back To External Doctor"><i class="fas fa-angle-double-left font-size-19px"></i></a>
          Add New External Doctor
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div>
        <form class="form " novalidate="" (ngSubmit)="Profile()" #f="ngForm">
          <div class="accordion" id="accordionExample">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Profile
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name Prefix</label>
                        </div>


                        <div class="col-md-1">

                          <CodeTypeValue CodeType="NPRE" id="CurrentSaveExternalDoctorInfoRequest.Salutation"
                                         name="CurrentSaveExternalDoctorInfoRequest.Salutation"
                                         [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.Salutation"></CodeTypeValue>

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="First Name"
                                 id="CurrentSaveExternalDoctorInfoRequest.DoctorName"
                                 [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.DoctorName"
                                 name="CurrentSaveExternalDoctorInfoRequest.DoctorName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                 maxlength="30" minlength="1" #Name1="ngModel" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!Name1.valid && (Name1.dirty || Name1.touched) && Name1.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Name1.valid && Name1.errors.pattern)">(special characters are not allowed)</small>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Clinic Name</label>
                        </div>


                        <div class="col-md-3">
                          <input type="text" class="form-control" placeholder="Clinic Name"
                                 id="CurrentSaveExternalDoctorInfoRequest.DoctorInstitute"
                                 [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.DoctorInstitute"
                                 name="CurrentSaveExternalDoctorInfoRequest.DoctorInstitute" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #InstituteName1="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!InstituteName1.valid && (InstituteName1.dirty || InstituteName1.touched) && InstituteName1.errors.required )">(Field cannot be left blank)</small>

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" (ngSubmit)="Roles()" #f="ngForm">
          <div class="accordion" id="accordionExample2">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne2">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne2" aria-expanded="true" aria-controls="collapseOne2">
                        Doctor Roles
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne2" class="collapse show" aria-labelledby="headingOne2" data-parent="#accordionExample2">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Primary Care Giver</label>
                        </div>


                        <div class="col-md-1">

                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.IsPrimaryCareGiver" name="CurrentSaveExternalDoctorInfoRequest.IsPrimaryCareGiver">

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Referral Doctor</label>
                        </div>


                        <div class="col-md-1">

                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.IsReferralDoctor" name="CurrentSaveExternalDoctorInfoRequest.IsReferralDoctor">

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Incharge Provider</label>
                        </div>


                        <div class="col-md-1">

                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.IsInchargeProvider" name="CurrentSaveExternalDoctorInfoRequest.IsInchargeProvider">

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" (ngSubmit)="Address()" #f="ngForm">
          <div class="accordion" id="accordionExample3">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne3">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne3">
                        Contact Address
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne3" class="collapse show" aria-labelledby="headingOne3" data-parent="#accordionExample3">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Line 1</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Line 1"
                                 id="CurrentSaveExternalDoctorInfoRequest.AddressLine1"
                                 [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.AddressLine1"
                                 name="CurrentSaveExternalDoctorInfoRequest.AddressLine1" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #AddressLinen1="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!AddressLinen1.valid && (AddressLinen1.dirty || AddressLinen1.touched) && AddressLinen1.errors.required )">(Field cannot be left blank)</small>


                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Line 2</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Line 2"
                                 id="CurrentSaveExternalDoctorInfoRequest.AddressLine2"
                                 [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.AddressLine2"
                                 name="CurrentSaveExternalDoctorInfoRequest.AddressLine2" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #AddressLinen2="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!AddressLinen2.valid && (AddressLinen2.dirty || AddressLinen2.touched) && AddressLinen2.errors.required )">(Field cannot be left blank)</small>


                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Country</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="CNTR" id="CurrentSaveExternalDoctorInfoRequest.Country"
                                         [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.Country" name="CurrentSaveExternalDoctorInfoRequest.Country"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">State</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="State" id="CurrentSaveExternalDoctorInfoRequest.State"
                                         [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.State" name="CurrentSaveExternalDoctorInfoRequest.State"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">City</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="City" id="CurrentSaveExternalDoctorInfoRequest.City"
                                         [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.City" name="CurrentSaveExternalDoctorInfoRequest.City"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Zip Code</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Zip Code"
                                 id="CurrentSaveExternalDoctorInfoRequest.ZipCode"
                                 [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.ZipCode"
                                 name="CurrentSaveExternalDoctorInfoRequest.ZipCode" #ZipCoden="ngModel"
                                 maxlength="6" pattern="[0-9]{6}">
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCoden.valid && (ZipCoden.dirty || ZipCoden.touched) && ZipCoden.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCoden.valid && ZipCoden.errors.pattern)">(only numbers are allowed)</small>

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" (ngSubmit)="Contact()" #f="ngForm">
          <div class="accordion" id="accordionExample4">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                        Contact Details
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample4">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Mobile Phone</label>
                        </div>


                        <div class="col-md-3">

                          <input type="tel" class="form-control" placeholder="Mobile Phone"
                                 id="CurrentSaveExternalDoctorInfoRequest.DoctorPhoneNo"
                                 [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.DoctorPhoneNo"
                                 mask="(000) 000-0000"
                                 name="CurrentSaveExternalDoctorInfoRequest.DoctorPhoneNo" pattern="[0-9]{10}" #Telephonenn1="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!Telephonenn1.valid)">(Provide Valid CellNo)</small>

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Email Address</label>
                        </div>


                        <div class="col-md-3">
                          <input type="email" class="form-control" id="SelectedProvider.Email"
                                 [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.Email"
                                 name="CurrentSaveExternalDoctorInfoRequest.Email"
                                 placeholder="Email" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                                 #Emailn="ngModel" maxlength="30" minlength="4">
                          <small class="form-text text-danger"
                                 *ngIf="(!Emailn.valid && (Emailn.dirty || Emailn.touched)  && Emailn.errors.required)">(Provide Valid Email)</small>
                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>

  <div class="card my-profile-form margin-top-15px top-link" *ngIf="EditDoctor">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="col-md-12">
        <div class="row">
          <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel()" title="Back To External Doctor"><i class="fas fa-angle-double-left font-size-19px"></i></a>
          Edit External Doctor
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div *ngIf="SelectedProvider">
        <form class="form " novalidate="" (ngSubmit)="ProfileEdit()" #f="ngForm">
          <div class="accordion" id="accordionExample">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Profile
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name Prefix</label>
                        </div>


                        <div class="col-md-1">

                          <CodeTypeValue CodeType="NPRE"
                                         id="SelectedProvider.Prefix" PassType="Long"
                                         [(ngModel)]="SelectedProvider.Prefix" name="SelectedProvider.Prefix" SelectedValue="{{SelectedProvider.Prefix}}"></CodeTypeValue>

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="First Name"
                                 id="SelectedProvider.DisplayName"
                                 [(ngModel)]="SelectedProvider.DisplayName"
                                 name="SelectedProvider.DisplayName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                 maxlength="30" minlength="1" #Name="ngModel" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!Name.valid && (Name.dirty || Name.touched) && Name.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Name.valid && Name.errors.pattern)">(special characters are not allowed)</small>


                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Clinic Name</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Clinic Name"
                                 id="SelectedProvider.ClinicName"
                                 [(ngModel)]="SelectedProvider.ClinicName"
                                 name="SelectedProvider.ClinicName" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #InstituteName="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!InstituteName.valid && (InstituteName.dirty || InstituteName.touched) && InstituteName.errors.required )">(Field cannot be left blank)</small>

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" (ngSubmit)="RolesEdit()" #f="ngForm">
          <div class="accordion" id="accordionExample2">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne2">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne2" aria-expanded="true" aria-controls="collapseOne2">
                        Doctor Roles
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne2" class="collapse show" aria-labelledby="headingOne2" data-parent="#accordionExample2">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Primary Care Giver</label>
                        </div>


                        <div class="col-md-1">

                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="SelectedProvider.IsPrimaryCareGiver" name="SelectedProvider.IsPrimaryCareGiver">

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Referral Doctor</label>
                        </div>


                        <div class="col-md-1">

                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="SelectedProvider.IsReferralDoctor" name="SelectedProvider.IsReferralDoctor">

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Is Incharge Provider</label>
                        </div>


                        <div class="col-md-1">

                          <input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="SelectedProvider.IsInchargeProvider" name="SelectedProvider.IsInchargeProvider">

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" (ngSubmit)="AddressEdit()" #f="ngForm">
          <div class="accordion" id="accordionExample3">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne3">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne3">
                        Contact Address
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne3" class="collapse show" aria-labelledby="headingOne3" data-parent="#accordionExample3">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Line 1</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Line 1"
                                 id="SelectedProvider.AddressLine1"
                                 [(ngModel)]="SelectedProvider.AddressLine1"
                                 name="SelectedProvider.AddressLine1" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #AddressLine1="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!AddressLine1.valid && (AddressLine1.dirty || AddressLine1.touched) && AddressLine1.errors.required )">(Field cannot be left blank)</small>

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Line 2</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Line 2"
                                 id="SelectedProvider.AddressLine2"
                                 [(ngModel)]="SelectedProvider.AddressLine2"
                                 name="SelectedProvider.AddressLine2" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #AddressLine2="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!AddressLine2.valid && (AddressLine2.dirty || AddressLine2.touched) && AddressLine2.errors.required )">(Field cannot be left blank)</small>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Country</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="CNTR" id="SelectedProvider.Country"
                                         [(ngModel)]="SelectedProvider.Country" SelectedValue="SelectedProvider.Country"
                                         name="SelectedProvider.Country"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">State</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="State" id="SelectedProvider.State"
                                         [(ngModel)]="SelectedProvider.State" SelectedValue="SelectedProvider.State"
                                         name="SelectedProvider.State"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">City</label>
                        </div>


                        <div class="col-md-3">

                          <CodeTypeValue CodeType="City" id="SelectedProvider.City"
                                         [(ngModel)]="SelectedProvider.City" SelectedValue="SelectedProvider.City"
                                         name="SelectedProvider.City"></CodeTypeValue>

                        </div>

                      </div>


                    </div>
                  </div>

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Zip Code</label>
                        </div>


                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="Zip Code"
                                 id="SelectedProvider.ZipCode"
                                 [(ngModel)]="SelectedProvider.ZipCode"
                                 name="SelectedProvider.ZipCode" #ZipCode="ngModel"
                                 maxlength="6" pattern="[0-9]{6}">
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCode.valid && (ZipCode.dirty || ZipCode.touched) && ZipCode.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCode.valid && ZipCode.errors.pattern)">(only numbers are allowed)</small>

                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div>
        <form class="form " novalidate="" (ngSubmit)="ContactEdit()" #f="ngForm">
          <div class="accordion" id="accordionExample4">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne4">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">
                        Contact Details
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                    <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                  </div>
                </div>


              </div>

              <div id="collapseOne4" class="collapse show" aria-labelledby="headingOne4" data-parent="#accordionExample4">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Mobile Phone</label>
                        </div>


                        <div class="col-md-3">

                          <input type="tel" class="form-control" placeholder="Mobile Phone"
                                 id="SelectedProvider.Telephone1"
                                 [(ngModel)]="SelectedProvider.Telephone1"
                                 mask="(000) 000-0000"
                                 name="SelectedProvider.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">
                        <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">Email Address</label>
                        </div>


                        <div class="col-md-3">

                          <!--<input type="email" class="form-control" placeholder="Email Address"
                                 pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$">-->
                          <input type="email" class="form-control" id="SelectedProvider.Email"
                                 [(ngModel)]="SelectedProvider.Email"
                                 name="SelectedProvider.Email"
                                 placeholder="Email" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                                 #Email="ngModel" maxlength="30" minlength="4">
                          <small class="form-text text-danger"
                                 *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>
                        </div>

                      </div>


                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>

</div>

<!--<div class="col-md-12" *ngIf="!ShowList">

  <profileview (GoBack)="OnGoBack()"
               [FormattedCode]="SelectedPatient.FormattedCode" [DisplayName]="SelectedPatient.DisplayName" *ngIf="ShowPatientDetails"></profileview>
</div>-->
